import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD, formatDateTime, formatDuration } from '../../../shared/format.js';
import { ReceiptBrand } from '../../../shared/ReceiptBrand.jsx';

const METHOD_LABEL = {
  cash: 'نقدي',
  card: 'بطاقة',
  card_balance: 'رصيد الكارت',
  credit: 'آجل',
  transfer: 'تحويل',
  external: 'خارجي'
};

export function ReceiptPreviewModal({ open, onClose, onPrint, data, printing }) {
  if (!open || !data) return null;

  const child = data.child || {};
  const guardian = data.guardian || {};
  const totals = data.totals || {};
  const payment = data.payment || {};
  const session = data.session || {};
  const sessions = Array.isArray(data.sessions) ? data.sessions : [];
  const childrenNames = sessions
    .map((s) => (s.childId && s.childId.name) || (s.child && s.child.name))
    .filter(Boolean);

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center p-4"
      style={{ background: 'rgba(15,16,18,0.55)' }}
    >
      <div
        className="bg-white rounded-[14px] shadow-card max-w-[420px] w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">إيصال الخروج النهائي</h3>
          <button type="button" className="text-ink-3 hover:text-ink" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="p-5 grid place-items-center" style={{ background: '#FAF6EE' }}>
          <div
            className="receipt-print-area bg-white p-4"
            style={{
              width: 280,
              fontFamily: '"Tajawal", monospace',
              fontSize: 12,
              boxShadow: '0 4px 14px rgba(0,0,0,.08)',
              borderRadius: 8
            }}
          >
            <ReceiptBrand subtitle="إيصال خروج نهائي" />
            <hr className="border-dashed my-1" />
            <RRow label="التاريخ" value={formatDateTime(new Date())} />
            {childrenNames.length > 1 ? (
              <>
                <RRow label="الأطفال" value={`${childrenNames.length}`} />
                <div className="text-[10.5px] mb-0.5">{childrenNames.join('، ')}</div>
              </>
            ) : (
              <RRow label="الطفل" value={child.name || '—'} />
            )}
            <RRow label="ولي الأمر" value={guardian.name || '—'} />
            <RRow label="المدة" value={formatDuration(totals.minutes || session.totalMinutes || 0)} />
            <hr className="border-dashed my-1" />
            <RRow label="رسوم اللعب" value={formatIQD(Number(totals.play || 0) + Number(totals.playPaid || 0))} />
            {Number(totals.companionsCount || 0) > 0 ? (
              <RRow
                label={`المرافقون (${totals.companionsCount})`}
                value={formatIQD(Number(totals.companionsDue || 0) + Number(totals.companionsPaid || 0))}
              />
            ) : null}
            <RRow label="الكافتيريا" value={formatIQD(totals.cafeteria || 0)} />
            <RRow label="محل الألعاب" value={formatIQD(totals.toys || 0)} />
            {Number(totals.discount || 0) > 0 ? (
              <RRow label="خصم رسوم اللعب" value={`- ${formatIQD(totals.discount)}`} />
            ) : null}
            {Number(totals.rounding || 0) > 0 ? (
              <RRow label="تقريب" value={`+ ${formatIQD(totals.rounding)}`} />
            ) : null}
            <hr className="border-dashed my-1" />
            <RRow label="الإجمالي" value={formatIQD(totals.grand || 0)} bold />
            <RRow label="مدفوع سابقاً" value={formatIQD(totals.paidBefore || 0)} />
            <RRow label="مدفوع الآن" value={formatIQD(payment.paidAmount || 0)} />
            <RRow label="طريقة الدفع" value={METHOD_LABEL[payment.method] || payment.method || '—'} />
            {Number(totals.change || 0) > 0 ? (
              <RRow label="الباقي للزبون" value={formatIQD(totals.change)} />
            ) : null}
            <hr className="border-dashed my-1" />
            <div className="text-center text-[10px] mt-2">شكراً لزيارتكم</div>
          </div>
        </div>
        <div className="card-h border-b-0 border-t flex gap-2">
          <button type="button" className="btn flex-1 justify-center" onClick={onClose}>
            إغلاق
          </button>
          <button
            type="button"
            className="btn btn-primary flex-1 justify-center"
            onClick={onPrint}
            disabled={printing}
          >
            <Icon name="print" size={14} />
            {printing ? 'جاري الطباعة...' : 'طباعة الإيصال'}
          </button>
        </div>
      </div>
    </div>
  );
}

function RRow({ label, value, mono, dir, bold }) {
  return (
    <div className="flex justify-between" style={{ padding: '1px 0' }}>
      <span>{label}:</span>
      <span dir={dir} style={{ fontFamily: mono ? 'monospace' : undefined, fontWeight: bold ? 800 : 600 }}>
        {value}
      </span>
    </div>
  );
}
